import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-move-to',
  templateUrl: './modal-move-to.component.html',
  styleUrls: ['./modal-move-to.component.scss']
})
export class ModalMoveToComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
